module.exports = __webpack_public_path__ + "img/red-presential.d304ecc7.svg";